import axios from '@/util/basehttp';
import qs from 'qs';


const pre = "/resource/base"

const resource = {
  paperPageList(pageSize, limit, keyWord, subjectId, classId, sortOne, sortTwo, sortThree) {
    return axios.get(pre + `/paperPageList`, {
      params:
        {
          pageSize: pageSize,
          limit: limit,
          keyWord: keyWord,
          subjectId: subjectId,
          classId: classId,
          sortOne: sortOne,
          sortTwo: sortTwo,
          sortThree: sortThree
        }
    });
  },
  paperInfo(id) {
    return axios.get(pre + `/paperInfo`, {params: {id: id}});
  },
  savePaper(params) {
    return axios.post(pre + `/savePaper`, qs.stringify(params));
  },
  uploadPaperResourceZip(formData) {
    return axios.post(pre + '/uploadPaperResourceZip', formData, {
      headers: {
        'Content-Type': 'multipart/form-data;charset=utf-8'
      }
    });
  },
  paperDelete(id) {
    return axios.delete(pre + `/paperDelete`, {params: {id: id}});
  },


  resourceTopicPageList(pageSize, limit, keyWord, subjectId, versionId, yearId) {
    return axios.get(pre + `/resourceTopicPageList`, {
      params:
        {
          pageSize: pageSize,
          limit: limit,
          keyWord: keyWord,
          subjectId: subjectId,
          versionId: versionId,
          yearId: yearId
        }
    });
  },
  resourceTopicInfo(id) {
    return axios.get(pre + `/resourceTopicInfo`, {params: {id: id}});
  },
  saveTopicResource(params) {
    return axios.post(pre + `/saveTopicResource`, qs.stringify(params));
  },
  resourceTopicDelete(id) {
    return axios.delete(pre + `/resourceTopicDelete`, {params: {id: id}});
  },
  uploadTopicResourceZip(formData) {
    return axios.post(pre + '/uploadTopicResourceZip', formData, {
      headers: {
        'Content-Type': 'multipart/form-data;charset=utf-8'
      }
    });
  },

  articlePageList(pageSize, limit, keyWord, typeId, classId, carrierId, numberId) {
    return axios.get(pre + `/articlePageList`, {
      params:
        {
          pageSize: pageSize,
          limit: limit,
          keyWord: keyWord,
          typeId: typeId,
          classId: classId,
          carrierId: carrierId,
          numberId: numberId,
        }
    });
  },
  articleInfo(id) {
    return axios.get(pre + `/articleInfo`, {params: {id: id}});
  },
  saveArticle(params) {
    return axios.post(pre + `/saveArticle`, qs.stringify(params));
  },
  articleDelete(id) {
    return axios.delete(pre + `/articleDelete`, {params: {id: id}});
  },
}
export default resource;



// WEBPACK FOOTER //
// ./src/api/resource/resource.js